import { axios } from '@Root/API'

export const get = id => {
	return axios.get(`qualification-award/${id}`)
}
